import { render, staticRenderFns } from "./CardTemplate.vue?vue&type=template&id=460077db&"
import script from "./CardTemplate.vue?vue&type=script&lang=ts&"
export * from "./CardTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports